import type { ScreenThresholds } from './types';

export const DRAG_CONSTANTS = {
	DEFAULT_BREAKPOINT: 960,
	MAX_HEADER_OFFSET: 60,
	CLICK_THRESHOLD: 5,
	POSITION_SNAP_THRESHOLD: 1,
	MOMENTUM_THRESHOLD: 0.5, // Reduced from 1 to make momentum more sensitive
	SCROLL_RESPONSIVENESS_FACTOR: 2.0, // Increased from 1.5 for more responsive scrolling
	MOMENTUM_MULTIPLIER: 2.0, // Increased from 1.5 for better momentum
	FRICTION_FACTOR: 0.88, // Reduced from 0.92 for faster deceleration
	HEADER_VELOCITY_DIVISOR: 6, // Reduced from 10 for more sensitive header response
	HEADER_VELOCITY_MULTIPLIER: 8, // Increased from 5 for faster header hiding
	MAX_VELOCITY_HISTORY_LENGTH: 3 // Reduced from 5 for quicker response
} as const;

export const SCREEN_THRESHOLDS: ScreenThresholds = {
	FULLY_OPEN: 0.7,
	HALF_OPEN: 0.5
} as const;

export const SPRING_CONFIG = {
	bounce: 0.06, // Reduced from 0.08 for snappier animations
	mass: 0.4, // Reduced from 0.5 for faster response
	duration: 800 // Reduced from 1000 for quicker animations
} as const;

export const MOTION_PROPERTIES_CONFIG = {
	cursor: 'grab',
	y: 0
} as const;

export const HEADER_OFFSET_CONFIG = {
	MAX_OFFSET: 60,
	MIN_OFFSET: 0,
	OFFSET_FACTOR: 6, // Reduced from 10 for more sensitive header movement
	// New constants for header behavior
	MOBILE_HEIGHT: 60,
	DESKTOP_HEIGHT: 80,
	HIDE_THRESHOLD: 1, // Minimum offset to apply header hiding
	SMOOTHING_FACTOR: 0.8, // Smoothing factor for drag offset calculations
	SCREEN_HEIGHT_RATIO_FOR_HALF_OPEN: 0.7 // Approximation for half-open position calculation
} as const;

export const TRANSITION_CONFIG = {
	DURATION: '0.15s',
	TIMING_FUNCTION: 'cubic-bezier(0.4, 0, 0.2, 1)'
} as const;
